var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSlotVisibility } from "@/hooks/layout";
import { useAppSelector } from "@/hooks/store";
import { Slot, SlotDirection } from "@/utils/types/layout";
import AddWidgetControl from "@/components/layout/edit/addWidget";
import WidgetGrid from "./widgetGrid";
import { useFilteredWidgets } from "@/utils/themes/hooks";
export default function MenuEast() {
    var menuEastVisible = useSlotVisibility().menuEastVisible;
    var filteredWidgets = useFilteredWidgets(Slot.MENU_EAST);
    var isEditingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    var areaVisible = (menuEastVisible && filteredWidgets.length > 0) || isEditingLayout;
    if (areaVisible) {
        if (filteredWidgets.length === 0 && !isEditingLayout) {
            return _jsx(_Fragment, {});
        }
        return (_jsxs("aside", __assign({ className: " ".concat(isEditingLayout && "border-[2px] border-[var(--colors-widget-border)]", " flex-none flex flex-col w-[var(--sizes-vertical-menu-expanded-width)]\n        mt-[var(--margin-mt-menu-east)] mr-[var(--margin-mr-menu-east)]\n        mb-[var(--margin-mb-menu-east)] ml-[var(--margin-ml-menu-east)]\n        bg-[var(--colors-menu-east-bg)] menu-east direction-vertical scroll-contain\n        overflow-hidden border-l-[var(--colors-layout-separator)]") }, { children: [_jsx("div", __assign({ className: "relative w-full h-full overflow-hidden widgets-container scroll-elements" }, { children: _jsx(WidgetGrid, { direction: SlotDirection.VERTICAL, filteredWidgets: filteredWidgets, isEditingLayout: isEditingLayout }) })), isEditingLayout && _jsx(AddWidgetControl, { to: Slot.MENU_EAST })] })));
    }
    return _jsx(_Fragment, {});
}
